import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15bafd7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "集团数据", -1))
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = {
  class: "high-light",
  style: { color: '#000' }
}
const _hoisted_8 = {
  class: "high-light",
  style: { color: 'blue' }
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_10 = { class: "box mark" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "中心数据", -1))
const _hoisted_12 = {
  key: 0,
  class: "space"
}
const _hoisted_13 = { class: "high-light" }
const _hoisted_14 = {
  class: "high-light",
  style: { color: '#000' }
}
const _hoisted_15 = {
  class: "high-light",
  style: { color: 'blue' }
}
const _hoisted_16 = { class: "high-light" }
const _hoisted_17 = { class: "high-light" }
const _hoisted_18 = { class: "box mark" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "区域数据", -1))
const _hoisted_20 = {
  key: 0,
  class: "space"
}
const _hoisted_21 = { class: "high-light" }
const _hoisted_22 = {
  class: "high-light",
  style: { color: '#000' }
}
const _hoisted_23 = {
  class: "high-light",
  style: { color: 'blue' }
}
const _hoisted_24 = { class: "high-light" }
const _hoisted_25 = { class: "high-light" }

import { ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Overlay, Loading } from "vant";
import createWatermark from "@/utils/watermark";
import dayjs, { Dayjs } from "dayjs";
import { numToMoney } from "@/utils";

import request from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  __name: 'PresidentOffice',
  setup(__props) {

const route = useRoute();
console.log(route?.params);

const visible = ref(false);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/invoice/list-group-returned",
    method: "POST",
    data: {
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(pageData.value.time).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              size: "large",
              title: "集团总应收：",
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(numToMoney)(pageData.value.groupReturned?.receivableAmount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Cell), {
              size: "large",
              title: "本年度累计开票：",
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(numToMoney)(pageData.value.groupReturned?.currYearInvoiceAmount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Cell), {
              size: "large",
              title: "本年度累计回款：",
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(numToMoney)(pageData.value.groupReturned?.currYearReturnedAmount)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_9,
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              title: "今日开票合计：",
              value: _unref(numToMoney)(pageData.value.groupReturned?.todayInvoiceAmount)
            }, null, 8, ["value"]),
            _createVNode(_unref(Cell), {
              title: "今日回款合计：",
              value: _unref(numToMoney)(pageData.value.groupReturned?.todayReturnedAmount)
            }, null, 8, ["value"]),
            _createVNode(_unref(Cell), {
              title: "本月开票合计：",
              value: _unref(numToMoney)(pageData.value.groupReturned?.currMonthInvoiceAmount)
            }, null, 8, ["value"]),
            _createVNode(_unref(Cell), {
              title: "本月回款合计：",
              value: _unref(numToMoney)(pageData.value.groupReturned?.currMonthReturnedAmount)
            }, null, 8, ["value"]),
            _createVNode(_unref(Cell), {
              title: "本年度货款开票（流水）：",
              value: 
              _unref(numToMoney)(pageData.value.groupReturned?.currYearGoodsInvoiceAmount)
            
            }, null, 8, ["value"]),
            _createVNode(_unref(Cell), {
              title: "本年度货款回款（流水）：",
              value: 
              _unref(numToMoney)(pageData.value.groupReturned?.currYearGoodsReturnedAmount)
            
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.centerReturnedList, (oneDept, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              (index > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : _createCommentVNode("", true),
              _createVNode(_unref(Cell), {
                size: "large",
                title: `${oneDept.dept}总应收：`,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(numToMoney)(oneDept.receivableAmount)), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "本年度累计开票：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(numToMoney)(oneDept.currYearInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "本年度累计回款：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(numToMoney)(oneDept.currYearReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Cell), {
                size: "large",
                border: false,
                title: "当天开票合计：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(numToMoney)(oneDept.todayInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.invoiceList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: index !== oneDept.invoiceList.length - 1 ? false : true,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.invoicePrice)
                }, null, 8, ["border", "title", "value"]))
              }), 128)),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "当天回款总计：",
                border: false,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(numToMoney)(oneDept.todayReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.returnedList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: index !== oneDept.returnedList.length - 1 ? false : true,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.returnedMoney)
                }, null, 8, ["border", "title", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ], 512), [
        [_vShow, pageData.value.centerReturnedList?.length]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.areaReturnedList, (oneDept, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              (index > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                : _createCommentVNode("", true),
              _createVNode(_unref(Cell), {
                size: "large",
                title: `${oneDept.dept}总应收：`,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(numToMoney)(oneDept.receivableAmount)), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "本年度累计开票：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(numToMoney)(oneDept.currYearInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "本年度累计回款：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(numToMoney)(oneDept.currYearReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Cell), {
                size: "large",
                border: false,
                title: "当天开票合计：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(numToMoney)(oneDept.todayInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.invoiceList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: index !== oneDept.invoiceList.length - 1 ? false : true,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.invoicePrice)
                }, null, 8, ["border", "title", "value"]))
              }), 128)),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "当天回款总计：",
                border: false,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(numToMoney)(oneDept.todayReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.returnedList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: index !== oneDept.returnedList.length - 1 ? false : true,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.returnedMoney)
                }, null, 8, ["border", "title", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ], 512), [
        [_vShow, pageData.value.areaReturnedList?.length]
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})